"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Panel = _interopRequireDefault(require("../Panel/Panel"));

var _NotificationModule = _interopRequireDefault(require("./Notification.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var titleIcons = {
  error: 'error',
  info: 'info-round',
  warning: 'alert',
  success: 'success-round'
};

var Notification = function Notification(_ref) {
  var title = _ref.title,
      titleIconName = _ref.titleIconName,
      className = _ref.className,
      description = _ref.description,
      variant = _ref.variant,
      onClose = _ref.onClose,
      actions = _ref.actions,
      hasCloseBtn = _ref.hasCloseBtn,
      size = _ref.size,
      classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, ["title", "titleIconName", "className", "description", "variant", "onClose", "actions", "hasCloseBtn", "size", "classes"]);

  return _react.default.createElement(_Panel.default, _extends({}, rest, {
    className: (0, _classnames.default)(className, _NotificationModule.default.wrapper, _NotificationModule.default[variant], _NotificationModule.default[size])
  }), _react.default.createElement("div", {
    className: _NotificationModule.default.header
  }, _react.default.createElement(_Icon.default, {
    type: titleIconName || titleIcons[variant],
    className: _NotificationModule.default.icon
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(_NotificationModule.default.title, classes.title)
  }, title), hasCloseBtn && _react.default.createElement(_Icon.default, {
    type: "close-medium",
    onClick: onClose,
    className: _NotificationModule.default.closeIcon
  })), description && _react.default.createElement("div", {
    className: (0, _classnames.default)(_NotificationModule.default.content, classes.content)
  }, description), actions && _react.default.createElement("div", {
    className: _NotificationModule.default.actions
  }, actions.map(function (_ref2) {
    var label = _ref2.label,
        onClick = _ref2.onClick;
    return _react.default.createElement("div", {
      key: label,
      className: _NotificationModule.default.action,
      onClick: onClick
    }, label);
  })));
};

process.env.NODE_ENV !== "production" ? Notification.propTypes = {
  className: _propTypes.default.string,
  description: _propTypes.default.node,
  hasCloseBtn: _propTypes.default.bool,
  titleIconName: _propTypes.default.string,
  onClose: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['info', 'warning', 'success', 'error']),
  size: _propTypes.default.oneOf(['large', 'small']),
  title: _propTypes.default.string.isRequired,
  classes: _propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string
  }),
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  }))
} : void 0;
Notification.defaultProps = {
  onClose: function onClose() {},
  variant: 'info',
  classes: {},
  size: 'large',
  hasCloseBtn: true
};
var _default = Notification;
exports.default = _default;